<template>
    <img
        :src="src"
        @click="click"/>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            default: ''
        }
    },
    methods: {
        click() {
            this.$emit('click')
        }
    }
}
</script>
